<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <q-card class="q-px-sm card-crud">
          <q-card-section class="q-py-sm card-title">
            <div class="crud-title">
              <translate>SEARCH_RESULT</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-pb-lg card-table">
            <jt-data-table
              v-if="nmInterface && !slots.table"
              ref="jtDataTable"
              class="table-crud"
              :forms="forms"
              :buttons="datatable.buttons"
              :buttons-filter="filterButtons"
              :fields="datatable.columns"
              :extra-params="extraParam"
              :default-http-options="defaultHttpOptions"
              :nm-interface="nmInterface"
              multiselect
              selection-force
              :row-buttons="rowButtons"
              :noneselect="noneselect"
              @selection="selection"
              @action-button="realizaAcao"
              :column-edit="formatCellContent"
            >
              <template v-if="slots.table" v-slot:table>
                <slot name="table"></slot>
              </template>

              <template v-slot:body="{ props }">
                <q-tr>
                  <q-td v-if="props" auto-width>
                    <q-checkbox
                      v-model="props.selected"
                      color="primary"
                    />
                  </q-td>

                  <q-td
                    v-for="col in props.cols"
                    :key="col.name"
                    :props="props"
                  >
                    <span
                      v-if="(() => {
                        col.htmlProcessed = formatCellContent({ col: col, props: props });
                        return col.htmlProcessed;
                      })()"
                    >
                      <div v-html="col.htmlProcessed"></div>
                    </span>
                    <span v-else>
                      {{ col.value }}
                    </span>
                  </q-td>
                </q-tr>

                <q-tr v-show="props.expand" :props="props">
                  <q-td colspan="100%">
                    <div class="row hidden-row">
                      <div
                        v-for="(col, key) in $refs.jtDataTable.hiddenColumns"
                        :key="key"
                        style="width: 33%;"
                      >
                        <label :for="'hidden-col-' + key">{{ col.label }}:</label>
                        <span :id="'hidden-col-' + key">{{ props.row[col.model || col.field] }}</span>
                      </div>
                    </div>
                  </q-td>
                </q-tr>
              </template>
            </jt-data-table>
          </q-card-section>
        </q-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud } from 'jtech-webcomps'
const { pageTable } = JtCrud

@Component({
  mixins: [pageTable]
})
class ContractItemCostCenterPageTable extends Vue {
  formatCellContent ({ col, props }) {
    switch (col.name) {
      case 'clientName':
        return `<span>${props.row.clientName}</span><br>
                <span style="font-size:x-small">${props.row.clientDocument}</span>
                - <span style="font-size:x-small">${props.row.clientTypeNmDescricao}</span>`
      case 'organizationalStructureName':
        return `<span>${props.row.organizationalStructureName}</span><br>
                <span style="font-size:x-small">${props.row.city}</span>`
    }
  }
}
export default ContractItemCostCenterPageTable
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.table-crud {
  .jt-datatable {
    height: 68vh !important;
  }
}

.simpleButtons {
  .container {
    padding: 0px;
    margin: 0px;
  }

  .card-title {
    display: none;
  }
}

.cleanLayout {
  .container {
    padding: 0px;
    margin: 0px;
  }

  .card-crud {
    box-shadow: none;
    padding: 0px !important;
  }

  .card-title {
    display: none;
  }

  .card-table {
    padding: 0px;
    margin-top: -5px;
  }
}

.crudButtons {
  .card-crud {
    .table-crud {
      .jt-datatable {
        min-height: 60vh !important;
        height: max-content !important
      }
    }
  }
}

.hidden-row {
  background-color: #f5f5f5;
  padding: 10px;
  border-top: 1px solid #e0e0e0;

  label {
    color: #555;
    margin-right: 5px;
  }
}
</style>
